import React from "react";

const Footer = () => {
  return (
    <footer className="font-semibold text-center bg-blue-700 p-3 text-white">
      Images courtesy of NASA's APOD API
    </footer>
  );
};

export default Footer;
